import { render } from "./HieroglyphicsTranslator.vue?vue&type=template&id=7c38eeb6&scoped=true"
import script from "./HieroglyphicsTranslator.vue?vue&type=script&lang=js"
export * from "./HieroglyphicsTranslator.vue?vue&type=script&lang=js"

import "./HieroglyphicsTranslator.vue?vue&type=style&index=0&id=7c38eeb6&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7c38eeb6"]])

export default __exports__